import MainLayout from '../layouts/main';
import OrderContainer from './container';

function OrderPage() {
  return (
    <MainLayout title={ORDER_PAGE_TITLE}>
      <OrderContainer />
    </MainLayout>
  );
}

export const ORDER_PAGE_TITLE = 'سفارش خرید';

export default OrderPage;
